import { useEffect } from "react";
import AgGridLayout from "@wrappers/layouts/AgGridLayout";
import { ColDef, GridApi, GridReadyEvent, RowNode } from "ag-grid-community";
import { TKeywordsActionObj } from "@ts/common-types";

interface IProps {
    bulkKeywordsRowData?: TKeywordsActionObj[];
    bulkKeywordsGridApi?: GridApi;
    setBulkKeywordsGridApi?: React.Dispatch<React.SetStateAction<GridApi>>;
    onBulkKeywordSelectionChanged: (event: GridReadyEvent) => void;
    bulkKeywordColumnDefs: ColDef[];
    kaModalStepCount: number;
}

const ReviewBulkKeywords: React.FC<IProps> = ({
    bulkKeywordsRowData,
    bulkKeywordsGridApi,
    setBulkKeywordsGridApi,
    onBulkKeywordSelectionChanged,
    bulkKeywordColumnDefs,
    kaModalStepCount,
}) => {
    useEffect(() => {
        if (bulkKeywordsRowData.length) {
            bulkKeywordsGridApi.forEachLeafNode((node: RowNode) =>
                node.setSelected(true)
            );
            bulkKeywordsGridApi.sizeColumnsToFit();
        }
    }, [bulkKeywordsRowData, bulkKeywordColumnDefs, bulkKeywordsGridApi]);

    return (
        <>
            <div
                id="keyword-analytics-second-step"
                style={{
                    border: "0.5px solid black",
                    height: "87%",
                    display: kaModalStepCount === 2 ? "" : "none",
                }}
            >
                <div
                    id="review-bulk-keyword-grid"
                    className="ag-theme-alpine"
                    style={{ height: "100%", width: "100%" }}
                >
                    <AgGridLayout
                        setGridApi={setBulkKeywordsGridApi}
                        rowData={bulkKeywordsRowData}
                        columnDefs={bulkKeywordColumnDefs}
                        onSelectionChanged={onBulkKeywordSelectionChanged}
                        isTotalRowsReq={false}
                    />
                </div>

                <div
                    className="totalCombinationsSelected my-1 text-danger"
                    style={{
                        fontSize: "1.1rem",
                    }}
                >
                    | Total combinations selected :{" "}
                    <span
                        id="total-selected-combinations-count"
                        className="text-success"
                    >
                        0
                    </span>
                </div>
            </div>
        </>
    );
};

export default ReviewBulkKeywords;
